import md5 from "md5";

export function restaurantsKey(restaurants = []) {
    if (restaurants.length === 0) {
        return "";
    }

    return md5(restaurants.map(({ id }) => id).sort().join());
}
